import { GridElement } from '../lib/spreadsheet/types';
import { DateTypeKeys, SourceKeys } from '../constant';

export interface CsvUpdateRequest {
  dateType: DateTypeKeys
  year: number;
  month: number;
  targetFile: SourceKeys
  rows: UpdateRow[];
}

export interface UpdateRow {
  rowId: number;
  historyId: number;
  columns: UpdateColumn[];
}

export interface UpdateColumn {
  key: string;
  value: string;
  original: string;
}

export interface CsvUpdateResponse {
  hasError: boolean;
  hasWarning: boolean;
  rows: UpdateResponseRow[];
}

export interface UpdateResponseRow {
  rowId: number;
  hasError: boolean;
  hasWarning: boolean;
  error: string;
  columns: UpdateResponseColumn[];
}

export interface UpdateResponseColumn {
  key: string;
  name: string;
  validationResult: 'ok' | 'error' | 'warning';
  value: string;
  originalData: string;
  error: string;
}

export function buildCsvUpdateRequest(request: CsvUpdateRequest, rows: GridElement[][]): CsvUpdateRequest {
  const updateRows: UpdateRow[] = rows.map((row): UpdateRow | null => {
    if (row === undefined || row.length === 0) {
      return null;
    }
    const rowId = row[0].rowId ?? 0;
    if (typeof rowId === 'number') {
      return {
        rowId,
        historyId: row[0].historyId ?? 0,
        columns: row.map((cell) => {
          const column: UpdateColumn = {
            key: cell.columnKey,
            value: cell.value.toString(),
            original: cell.beforeValue.toString(),
          };
          return column;
        }),
      };
    }
    console.error('rowId is not number');
    return null;
  }).filter((row) => row !== null);

  return {
    ...request,
    rows: updateRows,
  };
}
